import { Avatar, Carousel, Modal } from "antd";
import { ComputerDetailTable } from "../computer-detail-table";
import styles from "./styles.module.scss";
import {
  captureData,
  captureData1,
  captureData2,
  data,
  getUpdatedData,
  hardwareData,
  infoData,
  networkData,
  netwrokData,
  Revenue,
  RevenueData,
} from "./constants";
import { ComputersDetailTable2 } from "../computer-detail-table-2";
import { EyeOutlined } from "@ant-design/icons";
import { ReactComponent as NextIcon } from "icons/sliderNextIcon.svg";
import { ReactComponent as PreviousIcon } from "icons/sliderPreviousIcon.svg";

import {
  CrossIcon,
  DownTheLineRight,
  faceOn,
  FaceonIconLeft,
  FaceonIconRight,
  SmileIcon,
} from "icons";
import { downTheLine } from "utils/constants";
import { CommunicationReasons } from "./components";
import { ConditionalRenderer } from "components";
import { useRef, useState } from "react";
import { TicketsSearchFilter } from "pages/support-tickets/components";
import { PrioritySelect } from "pages/support-tickets/components/priority-select";
import { UseApiCallV2 } from "hooks";

export const ComputerDetailModalV2 = ({
  openDetailModal,
  handleCloseModal,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedIssueType, setSelectedIssueType] = useState("all");

  const sliderRef = useRef();
  const handleBeforeChange = (from, to) => {
    setCurrentSlide(to);
  };

  const studio_id = "BFEBFBFF00050657210890372400087"; // temporarily hardcoded
  // https://55chh4xpy0.execute-api.eu-central-1.amazonaws.com/default/get_studio_config
  const {
    data: studioConfig,
    isLoading: studioConfigLoading,
    error: studioConfigError,
  } = UseApiCallV2({
    url: "get_studio_config",
    method: "POST",
    skip: !openDetailModal,
    paramsData: {
      studio_id,
    },
  });
  let faceOnRight = null;
  let faceOnLeft = null;
  let downTheLine = null;

  function filterSpecificTypeData({ type, totalData }) {
    return totalData?.find((item) => item.Orientation === type);
  }

  if (studioConfig) {
    const totalData = Object.values(studioConfig);
    faceOnRight = filterSpecificTypeData({
      type: "FOR",
      totalData,
    });
    downTheLine = filterSpecificTypeData({
      type: "DTL",
      totalData,
    });
    faceOnLeft = filterSpecificTypeData({
      type: "FOL",
      totalData,
    });
  }

  const faceonRightCaptureMode = faceOnRight?.CaptureMode;
  const faceonRightCalibrationMode = faceOnRight?.CalibrationMode;

  const faceOnLeftCaptureMode = faceOnLeft?.CaptureMode;
  const faceOnLeftCalibrationMode = faceOnLeft?.CalibrationMode;

  const downTheLineCaptureMode = downTheLine?.CaptureMode;
  const downTheLineCalibrationMode = downTheLine?.CalibrationMode;

  const {
    data: studioInfo,
    isLoading: studioInfoLoading,
    error: studioInfoError,
  } = UseApiCallV2({
    url: "get_studio_information",
    method: "POST",
    skip: !openDetailModal,
    paramsData: {
      studio_id,
    },
  });
  const {
    data: studioHradwareInfo,
    isLoading: studioHradwareInfoLoading,
    error: studioHradwareInfoError,
  } = UseApiCallV2({
    url: "get_hardware_information",
    method: "POST",
    skip: !openDetailModal,
    paramsData: {
      studio_id,
    },
  });
  const {
    data: studioNetworkInfo,
    isLoading: studioNetworkInfoLoading,
    error: studioNetworkInfoError,
  } = UseApiCallV2({
    url: "get_studio_network",
    method: "POST",
    skip: !openDetailModal,
    paramsData: {
      studio_id,
    },
  });

  const studioInfoUpdated = getUpdatedData({
    apiObject: studioInfo,
    customData: infoData,
  });
  const studioHardwareUpdated = getUpdatedData({
    apiObject: studioHradwareInfo,
    customData: hardwareData,
  });
  const studioNetworkUpdated = getUpdatedData({
    apiObject: studioNetworkInfo,
    customData: networkData,
  });

  const cameraColumns = [
    {
      title: "Camera Mode",
      dataIndex: "cameraType",
      key: "cameraType",
      width: "10%",
      render: (text, row, index) => {
        const obj = {
          children:
            index === 1 ? (
              <div className={styles.customCell}></div>
            ) : (
              <div style={{ padding: "4px 16px" }}>{text}</div>
            ),
          props: {},
        };
        obj.props.className =
          index === 0 || index === 1
            ? "custom-padding-row0"
            : "custom-padding-row2";
        return obj;
      },
      //   className: "custom-padding-column",
    },
    {
      title: " ",
      dataIndex: "view",
      key: "view",
      width: "10%",
      align: "center",
      render: (_, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <row.icon />
          {row.view}
        </div>
      ),
    },
    {
      title: "Frame Rate",
      dataIndex: "Fps",
      key: "Fps",
      width: "10%",
      align: "center",
    },
    {
      title: "Resolution",
      dataIndex: "resolution",
      key: "resolution",
      width: "10%",
      align: "center",
    },
    {
      title: "Exposure Time",
      dataIndex: "ExposureTime",
      key: "ExposureTime",
      width: "10%",
      align: "center",
    },
    {
      title: "Gain",
      dataIndex: "Gain",
      key: "Gain",
      width: "10%",
      align: "center",
    },
    {
      title: "Digital Shift",
      dataIndex: "DigitalShift",
      key: "DigitalShift",
      width: "10%",
      align: "center",
    },
    {
      title: "White Balance Ratio",
      dataIndex: "WBR",
      key: "WBR",
      width: "10%",
      align: "center",
    },
    {
      title: "Gamma",
      dataIndex: "Gamma",
      key: "Gamma",
      width: "10%",
      align: "center",
      render: (value, row) => (
        <ConditionalRenderer condition={row.Fps}>
          {value ? <span style={{ color: "green" }}>✔️</span> : <CrossIcon />}
        </ConditionalRenderer>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, row) => (
        <ConditionalRenderer condition={row.Fps}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src="./assets/icons/eye.svg"
              alt="Icon"
              style={{
                width: "15.11px",
              }}
            />
          </div>
        </ConditionalRenderer>
      ),
    },
  ];
  const faceOnRightResolution = faceOnRight?.ImageWidth
    ? `${faceOnRight?.ImageWidth} x ${faceOnRight?.ImageHeight}`
    : undefined;
  const downThelineResolution = downTheLine?.ImageWidth
    ? `${downTheLine?.ImageWidth} x ${downTheLine?.ImageHeight}`
    : undefined;
  const faceOnLeftResolution = faceOnLeft?.ImageWidth
    ? `${faceOnLeft?.ImageWidth} x ${faceOnLeft?.ImageHeight}`
    : undefined;

  const cameraData = [
    {
      key: "1",
      cameraType: "Right Handed",
      icon: FaceonIconRight,
      view: "Face On Right",
      resolution: faceOnRightResolution,
      ...faceonRightCaptureMode,
    },
    {
      key: "2",
      cameraType: "",
      icon: DownTheLineRight,
      view: "Down the Line",
      resolution: downThelineResolution,
      ...downTheLineCaptureMode,
    },
    {
      key: "3",
      cameraType: "Left Handed",
      icon: FaceonIconLeft,
      view: "Face On Left",
      resolution: faceOnLeftResolution,
      ...faceOnLeftCaptureMode,
    },
  ];
  const calibrationColumns = [
    {
      title: "Calibration Mode",
      dataIndex: "cameraType",
      key: "cameraType",
      width: "10%",
      render: (text, row, index) => {
        const obj = {
          children:
            index === 1 ? (
              <div className={styles.customCell}></div>
            ) : (
              <div style={{ padding: "14px 16px" }}>{text}</div>
            ),
          props: {},
        };
        obj.props.className =
          index === 0 || index === 1
            ? "custom-padding-row0"
            : "custom-padding-row2";
        return obj;
      },
      //   className: "custom-padding-column",
    },
    {
      title: " ",
      dataIndex: "view",
      key: "view",
      align: "center",
      width: "10%",
      render: (_, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <row.icon /> {row.view}
        </div>
      ),
    },
    {
      title: "Frame Rate",
      dataIndex: "Fps",
      key: "Fps",
      width: "7%",
      align: "center",
    },
    {
      title: "Resolution",
      dataIndex: "resolution",
      key: "resolution",
      width: "7%",
      align: "center",
    },
    {
      title: "Exposure Time",
      dataIndex: "ExposureTime",
      key: "ExposureTime",
      width: "10%",
      align: "center",
    },
    {
      title: "Gain",
      dataIndex: "Gain",
      key: "Gain",
      width: "5%",
      align: "center",
    },
    {
      title: "Digital Shift",
      dataIndex: "DigitalShift",
      key: "DigitalShift",
      width: "6%",
      align: "center",
    },
    {
      title: "White Balance Ratio",
      dataIndex: "WBR",
      key: "WBR",
      width: "10%",
      align: "center",
    },
    {
      title: "Gamma",
      dataIndex: "Gamma",
      key: "Gamma",
      width: "5%",
      align: "center",
      render: (value, row) => (
        <>
          <ConditionalRenderer condition={row.Fps}>
            {value ? <span style={{ color: "green" }}>✔️</span> : <CrossIcon />}
          </ConditionalRenderer>
        </>
      ),
    },

    {
      title: "Quality",
      dataIndex: "quality",
      key: "quality",
      width: "7.1%",
      align: "center",
    },
    {
      title: "Last Calibrated",
      dataIndex: "lastCalibrated",
      key: "lastCalibrated",
      width: "8.1%",
      align: "center",
    },
    {
      title: "Last Validated",
      dataIndex: "lastValidated",
      key: "lastValidated",
      width: "7.1%",
      align: "center",
    },
    {
      title: "Overall Status",
      dataIndex: "overallStatus",
      key: "overallStatus",
      width: "9%",
      align: "center",
      render: (text, row, index) => {
        const obj = {
          children: (
            <div className={styles.valueTag}>
              <SmileIcon />
              {row.overallStatus}
            </div>
          ),
          props: {},
        };
        if (index === 0) obj.props.rowSpan = 3;
        if (index === 1) obj.props.rowSpan = 0;
        if (index === 2) obj.props.rowSpan = 0;

        return obj;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, row) => (
        <ConditionalRenderer condition={row.Fps}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img
              src="./assets/icons/eye.svg"
              alt="Icon"
              style={{ width: "15.11px" }}
            />
          </div>
        </ConditionalRenderer>
      ),
    },
  ];

  const calibrationData = [
    {
      key: "1",
      cameraType: "Right Handed",
      icon: FaceonIconRight,
      view: "Face On Right",
      resolution: faceOnRightResolution,
      ...faceonRightCalibrationMode,
    },
    {
      key: "2",
      cameraType: "",
      icon: DownTheLineRight,
      view: "Down The Line",
      resolution: downThelineResolution,

      ...downTheLineCalibrationMode,
    },
    {
      key: "3",
      cameraType: "Left Handed",
      icon: FaceonIconLeft,
      view: "Face On Left",
      resolution: faceOnLeftResolution,

      ...faceOnLeftCalibrationMode,
    },
  ];

  const dataList = [
    {
      title: "infoData",
      data: studioInfoUpdated,
    },
    {
      title: "hardwareData",
      data: studioHardwareUpdated,
    },
    {
      title: "networkData",
      data: studioNetworkUpdated,
    },
    {
      title: "captureData1",
      data: captureData1,
    },
    {
      title: "captureData2",
      data: captureData2,
    },
    {
      title: "RevenueData",
      data: RevenueData,
    },
  ];

  const tablesList = [
    {
      title: "cameraMode",
      columns: cameraColumns,
      data: cameraData,
    },
    {
      title: "calibrationMode",
      columns: calibrationColumns,
      data: calibrationData,
    },
  ];

  const handlePrev = () => sliderRef?.current?.goTo(0);

  const handleNext = () => sliderRef?.current?.next();

  function handleChangeIssueType(data) {
    setSelectedIssueType(data?.value);
  }
  const issueTypeArr = [
    { value: "general", label: "General" },
    {
      value: "subscription",
      label: "Subscription",
    },
    {
      value: "Cameras",
      label: "Cameras",
    },
    { value: "Force Plates", label: "Force Plates" },
    {
      value: "Calibration",
      label: "Calibration",
    },
    { value: "Capturing", label: "Capturing" },
    { value: "System Blockage", label: "System Blockage" },
    { value: "Bugs", label: "Bugs" },
    { value: "Values", label: "Values" },
  ];

  return (
    <Modal
      className={styles.modal}
      open={openDetailModal}
      onCancel={handleCloseModal}
      onOk={handleCloseModal}
      footer={false}
      width="100%"
      centered
      title={
        currentSlide === 0 ? (
          <Title username={studioInfo?.username} />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "0 20px 0 0",
              alignItems: "center",
            }}
          >
            <div>Communication Reasons</div>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <div className={styles.issue}>Issue Type</div>
              <PrioritySelect
                options={issueTypeArr}
                placeholder="All"
                onChange={handleChangeIssueType}
                variant="ticket-preference"
              />
            </div>
          </div>
        )
      }
    >
      <ConditionalRenderer condition={currentSlide === 0}>
        <NextIcon className={styles.nextIcon} onClick={handleNext} />
      </ConditionalRenderer>
      <ConditionalRenderer condition={currentSlide === 1}>
        <PreviousIcon className={styles.previousIcon} onClick={handlePrev} />
      </ConditionalRenderer>
      <Carousel
        dots={false}
        ref={sliderRef}
        infinite={false}
        className={styles.carouselContainer}
        beforeChange={handleBeforeChange}
      >
        <div>
          <div className={styles.detailModal}>
            {dataList.map((item) => (
              <ComputerDetailTable data={item.data} key={item.title} />
            ))}
          </div>
          <div>
            {tablesList.map((item) => (
              <ComputersDetailTable2
                key={item.title}
                columns={item.columns}
                data={item.data}
              />
            ))}
          </div>
        </div>

        <CommunicationReasons />
      </Carousel>
    </Modal>
  );
};

function Title({ username }) {
  const name = updateName(username);
  function updateName(name) {
    if (!name) return;
    return name.replace("_", " ");
  }

  return (
    <div className={styles.user} style={{ textTransform: "capitalize" }}>
      <Avatar shape="circle" />
      {name}
    </div>
  );
}
function CommunicationTitle({ userDetail }) {
  return <div className={styles.user}>Communication Reasons</div>;
}
